import { render } from "./CirculacaoItem.vue?vue&type=template&id=eda8f430"
import script from "./CirculacaoItem.vue?vue&type=script&lang=js"
export * from "./CirculacaoItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__